/** @file Deletes a slot with its skin entries, timelines and draw-order places (removeEntity). */
import { defineRemove } from '../_shared/defineRemove';

/** slot.delete: attachments left without any skin entry go too (the INFO warning counts them). */
export const command = defineRemove({
  domain: 'slot',
  kind: 'slot',
  description: 'Delete a slot with its skin entries, its timelines and its place in drawOrder and in draw-order keys; attachments left without any skin entry are deleted too (a warning counts them).',
});
